import React, { useState, useEffect } from "react";
import {
  cancelarSubcripcion,
  GenerarSubcripcion,
  enviarSubscripcion,
  tieneSubcripcion,
} from "../../../utils/Notificaciones";

import "./settings.css";

export default function Settings(props) {
  const { language, alto } = props;
  const [setting, setSetting] = useState({
    language: language,
    soundChecked: localStorage.getItem("sound") === "true" ? true : false,
    notification: false,
  });

  useEffect(() => {
    tieneSubcripcion(setting, setSetting);
  }, []);

  const changeSound = (e) => {
    setSetting({ ...setting, soundChecked: e.target.checked });
    localStorage.setItem("sound", e.target.checked);
  };

  const changeNotification = (e) => {
    if (e.target.checked) {
      GenerarSubcripcion().then((result) => {
        enviarSubscripcion(result);
        setSetting({ ...setting, notification: true });
      });
    } else {
      cancelarSubcripcion(setSetting, setting);
    }
  };

  return (
    <div className='settings_contenedor' style={{ height: alto + "px" }}>
      <div className='settings_contenido'>
        <ul
          className='collection'
          style={{ width: "100%", marginTop: "0px", overflowY: "auto" }}
        >
          <li
            className='collection-item'
            style={{ height: "80px", padding: "0px" }}
          >
            <div className='item_div0'>
              <div className='item_div1'>
                <i
                  className='material-icons left'
                  style={{
                    fontSize: "26px",
                    position: "relative",
                    top: "2px",
                  }}
                >
                  volume_up
                </i>
                {setting.language === "en" ? "Sound" : "Sonido"}
              </div>
              <div className='item_div2'>
                <div className='switch'>
                  <label style={{ fontSize: "14px" }}>
                    {/*  {this.state.language === 'en' ? 'Off' : 'No'}  */}
                    <input
                      type='checkbox'
                      checked={setting.soundChecked}
                      onChange={changeSound}
                    />
                    <span className='lever'></span>
                    {/*  {this.state.language === 'en' ? 'On' : 'Si'}  */}
                  </label>
                </div>
              </div>
            </div>
          </li>

          <li
            className='collection-item'
            style={{ height: "80px", padding: "0px" }}
          >
            <div className='item_div0'>
              <div className='item_div1'>
                <i
                  className='material-icons left'
                  style={{
                    fontSize: "26px",
                    position: "relative",
                    top: "2px",
                  }}
                >
                  notifications
                </i>
                {setting.language === "en" ? "Notifications" : "Notificaciones"}
              </div>
              <div className='item_div2'>
                <div className='switch'>
                  <label style={{ fontSize: "14px" }}>
                    {/*  {this.state.language === 'en' ? 'Off' : 'No'}  */}
                    <input
                      type='checkbox'
                      checked={setting.notification}
                      onChange={changeNotification}
                    />
                    <span className='lever'></span>
                    {/*  {this.state.language === 'en' ? 'On' : 'Si'}  */}
                  </label>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
